/* eslint-disable react/no-unescaped-entities */
import { useStore } from '@/models/root-store';
import { TipKey } from '@/utils/constants';

const ShippingInfo = () => {
  const { generalStore } = useStore();
  const allTips = generalStore.getTipByKey(TipKey.RECURRING_DELIVERY_TIPS_LG);
  return (
    <>
      <div className="flex-row p-2">
        <div
          className="mb-2 font-inter text-sm leading-[16px]"
          dangerouslySetInnerHTML={{ __html: allTips }}
        ></div>
      </div>
      <div className="pl-2 font-interMedium text-xs text-grey-dark">
        *Terms & Conditions apply
      </div>
    </>
  );
};

export default ShippingInfo;
